export default __webpack_public_path__ + "assets/webgl/malus.c79c2b48.png";